<template>
  <div class="flex items-center" :class="[data.cssClass]" :qaid="qaid">
    <i
      ref="`tippy_${tippyId}`"
      v-tippy="tippyConfig"
      class="b2b-grid__icon material-icons"
      :class="{'has-notification': data.hasNotification}"
      >{{ data.value }}</i
    >
    <div v-if="hasTippy && tippyContent" :id="tippyId" v-tippy-html class="max-w-xs" style="display: none">
      <div class="text-left p-1">{{ tippyContent }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {},
    },
    tippyContent: {
      type: String,
      default: '',
    },
    hasTippy: {
      type: Boolean,
      default: false,
    },
    qaid: {
      type: String,
      default: '',
    },
  },
  computed: {
    tippyConfig() {
      if (this.data.tooltipContent) {
        return {
          html: `#${this.tippyId}`,
          theme: 'light',
          interactive: true,
          sticky: true,
        };
      } else {
        return false;
      }
    },
    tippyId() {
      return `tippy-${Math.random()
        .toString(36)
        .substring(7)}`;
    },
  },
};
</script>
